import { z } from 'zod';

export enum SystemParameterName {
	newEmployeeGracePeriod = 'newEmployeeGracePeriod',
	trainingReviewGracePeriod = 'trainingReviewGracePeriod',
	newBlockGracePeriod = 'newBlockGracePeriod',
	changesEmployeeGracePeriod = 'changesEmployeeGracePeriod',
}

export const PARAMETER_DESCRIPTIONS: Record<SystemParameterName, string> = {
	[SystemParameterName.newEmployeeGracePeriod]:
		'Ao prosseguir com esta ação, todo novo colaborador fora do período de carência poderá ser bloqueado nos Polos.',
	[SystemParameterName.trainingReviewGracePeriod]:
		'Ao prosseguir com esta ação, todo treinamento com nova revisão após o fim do período de carência poderá bloquear colaboradores nos Polos.',
	[SystemParameterName.newBlockGracePeriod]:
		'Ao prosseguir com esta ação, todo novo bloqueio após o fim do período de carência poderá bloquear colaboradores nos Polos.',
	[SystemParameterName.changesEmployeeGracePeriod]:
		'Ao prosseguir com esta ação, todo colaborador que teve alteração de cargo, local de trabalho ou coordenação após o fim do período de carência poderá ser bloqueado nos Polos.',
};

export const getParameterDescription = (name: SystemParameterName): string => {
	return (
		PARAMETER_DESCRIPTIONS[name] ||
		'Ao prosseguir com esta ação, os parâmetros da catraca serão alterados.'
	);
};

export const SystemParameterSchema = z.object({
	id: z.coerce.number(),
	name: z.nativeEnum(SystemParameterName),
	value: z.string(),
	description: z.string(),
	updatedBy: z.string(),
	updatedAt: z.coerce.date(),
});

export const SystemParametersSchema = z.object({
	count: z.number(),
	nextPage: z.number().optional(),
	parameters: z.array(SystemParameterSchema),
});

export type SystemParameter = z.infer<typeof SystemParameterSchema>;
export type SystemParameters = z.infer<typeof SystemParametersSchema>;
